import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import {  NavLink } from "react-router-dom";
import NumberFormat from 'react-number-format';

export default function Paso1(props) {
      
    const { register, handleSubmit , formState: { errors }} = useForm();
    const toastId = React.useRef(null);
    const today = new Date().toISOString().slice(0, 10);
    
    const [ spinner, setSpinner ] = useState(false);
    const [ monto, setMonto ] = useState(0);

    const onSubmit = async (data) => {
        if(monto <= 0) {
            if(! toast.isActive(toastId.current)) {
                toast.error( ('Ingrese el monto a solicitar'), {
                  position: "top-center",
                  autoClose: false,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                    });
            }
            return false;
        }
        data = { ...data, monto}
        setSpinner(true)

        window.grecaptcha.ready(async function() {
          window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_KEY, {action: 'submit'}).then(async function(captchaToken) {
              const localToken = localStorage.getItem('token')
  
              const options = {
                  headers: {
                      'Content-Type': 'application/json',
                      'token': localToken,
                      'captchatoken': captchaToken
                  }
              };
              try {
                  const { data: data_resp } = await axios.post(process.env.REACT_APP_URL_API+process.env.REACT_APP_STEP2, JSON.stringify(data), options)
                  if(data_resp.msg || !data_resp.token ){

                      if(! toast.isActive(toastId.current)) {
                          toast.error( (data_resp.msg || 'Ocurrió un error inténtalo nuevamente'), {
                            position: "top-center",
                            autoClose: false,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                              });
                      }
                  } else {
                    localStorage.setItem('token', data_resp.token)
                    window.location.href=  process.env.REACT_APP_URL;
                  }
              
              } catch(e){
                localStorage.clear('token')
                window.location.href= process.env.REACT_APP_URL;
              }
              setSpinner(false)
          });
        });
        
    }
   
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <ToastContainer
        position="top-center"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        />
      <div>      
      {spinner &&  <div className="loading">
      <div className="uil-ring-css">
          <div></div>
      </div>
      </div>
  }
          <div>
          <div className="proceso">
            <div className="line">
                <hr />
            </div>
            <div className="linea-pasos">
                <div className="center">
                    {/* <a class="paso-active" href="index.html">1</a> */}
                    <NavLink className="paso-active" activeClassName="paso-active" to="/">1</NavLink>
                    <p>DATOS PERSONALES</p>
                </div>
                <div className="center">
                    {/* <a class="paso" href="montos.html">2</a> */}
                    <NavLink className="paso-active" to="/">2</NavLink>
                    <p>MONTO Y PLAZO</p>
                </div>
                <div className="center">
                    {/* <a class="paso" href="simulacion.html">3</a> */}
                    <NavLink className="paso" to="/">3</NavLink>
                    <p>SIMULACIÓN</p>
                </div>
            </div>    
        </div>
      </div>  
         <div className="campos">
                <div className="linea1">
                    <div className="container">
                        <p>Monto solicitado <small>(Ej. 1000000)</small></p>
                        <div className="caja">
                            <i className="fas fa-dollar-sign"></i>
                            <NumberFormat className="box monto"  decimalScale={0} maxLength="15" onValueChange={(values) => { const { value } = values; setMonto(value); }} thousandSeparator={'.'} decimalSeparator={','} allowNegative={false} name="monto" />
                        </div>    
                        {(errors.monto) && <div className="error-p">Ingrese monto a solicitar</div>}

                    </div>
                    <div className="container">
                        <p>Tipo de retiro</p>

                        <div className="caja-select">
                          <select name="tipo"  {...register("tipo", { required: true  })}>
                            <option value="O">Obligatorio</option>
                            <option value="V">Voluntario</option>
                          </select>
                        </div>
                        {(errors.tipo) && <div className="error-p">Seleccione tipo de retiro</div>}

                    </div>
                </div>
                <div className="linea1">
                    <div className="container">
                        <p>Fecha de simulación</p>
                        <div className="caja">
                            <input className="box" type="date" name="f_simulacion"  onKeyDown={(e) => e.preventDefault()} {...register("f_simulacion", { required: true, value: today })}/>
                        </div>
                        {(errors.f_simulacion) && <div className="error-p">Seleccione fecha de simulación</div>}

                    </div>
                    <div className="container">
                        <p>Fecha estimada de pago</p>
                        <div className="caja">
                            <input className="box" type="date" name="f_pago"  onKeyDown={(e) => e.preventDefault()} {...register("f_pago", { required: true  })} />
                        </div>    
                        {(errors.f_pago) && <div className="error-p">Seleccione fecha de pago</div>}

                    </div>
                </div>

               <div className="termsx">
<center>TÉRMINOS Y CONDICIONES DE SIMULACIÓN DE PRESTAMO DE DESAHUCIO ONLINE<br /></center>
1. GENERAL<br />
Los siguientes términos y condiciones regulan la simulación online, de préstamos que puede otorgar Mutual de Seguros de Chile (la “Mutual”), a quien se encuentre actualmente incorporado a los seguros de vida colectivos contratados con ésta por la Armada de Chile, denominados por la sigla “SECORA” o “SECOAL”, y que además tengan derecho a desahucio en los términos establecidos en el párrafo 5° del Título V, de la Ley N°18.948, por acogerse a retiro de la Armada (en adelante “el usuario”), y siempre que se otorgue con la Mutual un contrato de línea de crédito para otorgar préstamos de desahucio y un mandato en virtud del cual se encomendará a esta última el cobro del desahucio ante la Caja de Previsión de la Defensa Nacional, cuyo producto será destinado a satisfacer los préstamos otorgados con cargo a la línea de crédito, incluyendo el capital, intereses y gastos relacionados.<br />
La apertura de la línea de crédito requiere la previa presentación por parte del usuario, de un certificado extendido por la dirección correspondiente de la Armada de Chile en que se exprese que habiéndose acogido, o encontrándose próximo a acogerse a retiro de la Institución, le corresponde recibir un desahucio por años de servicio, señalándose, el monto aproximado y la fecha aproximada en que el mismo debiese ser pagado por la Caja de Previsión de la Defensa Nacional.<br />
Con el mérito de dicho certificado y del análisis de los antecedentes comerciales y crediticios del usuario, la Mutual podrá aprobar la línea de crédito por un porcentaje del valor que figure en el certificado que se cita en el párrafo precedente, la cual quedará a disposición del usuario para la solicitud de uno o más préstamos de desahucio, hasta el monto límite antes referido. <br />
El usuario podrá hacer uso de la línea de crédito y obtener los préstamos a que se refiere el párrafo anterior, siempre que no haya obtenido personalmente o a través de un mandatario el desahucio que le corresponde en virtud de la ley.<br />
Los préstamos serán efectuados en moneda nacional, no estarán afectos a reajustes y se otorgarán con una tasa de interés que se fija según la fecha en que se solicité el préstamo, y se informará en la cotización y hoja resumen respectiva. <br />
Por el solo hecho de ingresar al portal para simular un Préstamo de Desahucio, se entiende que los usuarios conocen y aceptan, sin limitación alguna, los términos y condiciones aquí consignados, así como las normas legales y reglamentarias que aplicables.<br />

<br /><br />
2. DATOS PERSONALES Y TRATAMIENTO<br />
Para simular un préstamo de desahucio, el usuario deberá incorporar los siguientes  datos personales: nombre, apellidos, RUT, correo electrónico (e-mail) y número telefónico. <br />
Los antecedentes personales que los usuarios proporcionen a través de este portal, serán tratados bajo estricta reserva.<br />
El usuario autoriza a la Mutual para hacer tratamiento de sus datos de carácter personal de naturaleza no sensible, en los términos y condiciones establecidos en la Ley N° 19.628 y sus modificaciones, cuando ello fuere necesario o conveniente para la materialización o implementación de promociones, ofertas de productos, nuevos servicios, investigación de mercado, encuestas de opinión y otros. <br />
Los datos personales podrán ser modificados o eliminados de la base de datos de la Mutual, para lo cual bastará una comunicación del usuario en ese sentido a la casilla prestamosdesahucio@mutualdeseguros.cl.<br />
<br /><br />
3. SIMULACION Y APROBACION. <br />
La plataforma de simulación entregará un resultado preliminar y no constituye aprobación del préstamo por parte de Mutual de Seguros de Chile.<br />
El monto de la simulación debe ser de al menos $1.000.000.-<br />
<br /><br />
4. GASTOS<br />
Los gastos generados por el otorgamiento de préstamos de desahucio serán de cargo del usuario, los que incluyen principalmente:<br />
- El impuesto de timbres y estampillas de conformidad a lo establecido en el Decreto Ley N°3475 de 1980.<br />
- Gastos notariales por legalización del contrato de línea de crédito y el mandato especial conferido a la Mutual.<br />
- La prima del seguro de desgravamen que debe contratar el usuario para el otorgamiento de los préstamos de desahucio, en caso de que dicho seguro sea tomado con Mutual de Seguros de Chile. <br />

          </div>


                {(errors.terminos) && <div className="error-p">Debe aceptar términos y condiciones</div>}

                <div className="terminos-y-condiciones">
                    <input type="checkbox" name="terminos" {...register("terminos", { required: true  })}/><p>Acepto los Términos y Condiciones.</p>
                </div>
               <div className="boton">
                    <button type="submit">SIMULAR</button>
                </div>
                <div className="boton">
                    <button type="button" onClick={(e)=> { e.preventDefault(); window.localStorage.setItem('token',''); window.location=process.env.REACT_APP_URL;}} className="otroRUT">Simular con otro RUT</button>
                </div>

        </div>
      </div>
      </form>
    );
}